import {doc} from '../../docs.js';
import {uuid} from 'uuidv4';
import {float, extract} from '../utils.js';
import {lazy} from '../lazy.js';

doc(
    'gl.genArg',
    {
        "name": "Name of the function argument",
        "type": "Type of the function argument",
    },
    "Generates a vec3 arguement that can be used in a function definition",
    () => 1,
    {
        inlets: 2
    });

export const genArg = (o, type) => {
    return ([name]) => {
        console.log("GEN ARG CALLED=", name);
        let closure = {
        };
        closure[name] = type();
        return {
            code: `(${name})`,
            uniforms: {},
            variables: {},
            closure
        };
    };
};

doc(
    'gl.genFunction',
    {
        "network": "Name of the function that is generated",
        "name": "Name of the function that is generated",
        "returnType": "Name of the function that is generated",
        "argument name list": "exact name of arguments (in list)"
    },
    "Generates a function",
    () => 1,
    {
        inlets: 4
    }
);

const sortClosureByNames = (closure, argNames) => {
    let _closure = {};
    for (let arg of argNames) {
        _closure[arg] = closure[arg];
    }
    return _closure;
};

export const genFunction  = (obj, name, returnType, argNames) => {
    let id = uuid().replaceAll('-', '');
    return ([network]) => {
        let _name = name() + 'generated' + id;
        let extracted = extract(network, name);
        let {codes, uniforms, functions, closure} = extracted;

        if (argNames()) {
            closure = sortClosureByNames(closure, argNames());
        }
        console.log("CLOSURES =", closure, argNames());
        functions[_name] = {
            args: closure,
            returnType: returnType(),
            body: `
return ${codes[0]};
`
        };

        let fn = {
            codeEvaluator: (x) => `(${_name}(${x}))`,
            uniforms,
            variables: {},
            functions
        };
        return fn;
    };
};

export const gl_functional = {
    "gl.genArg": genArg,
    "gl.genFunction": genFunction
}

